import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance,
} from '../channels/BufferOverflow.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ChannelFlowOperatorImpl3gjkp847e0ebc as ChannelFlowOperatorImpl,
  FusibleFlow2tgh9s2p1kryd as FusibleFlow,
} from './internal/ChannelFlow.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2rlngjw9v1qsd as Key_instance } from '../Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buffer(_this__u8e3s4, capacity, onBufferOverflow) {
  capacity = capacity === VOID ? -2 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  // Inline function 'kotlin.require' call
  if (!(capacity >= 0 || capacity === -2 || capacity === -1)) {
    var message = 'Buffer size should be non-negative, BUFFERED, or CONFLATED, but was ' + capacity;
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(!(capacity === -1) || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
    var message_0 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var capacity_0 = capacity;
  var onBufferOverflow_0 = onBufferOverflow;
  if (capacity_0 === -1) {
    capacity_0 = 0;
    onBufferOverflow_0 = BufferOverflow_DROP_OLDEST_getInstance();
  }
  var tmp;
  if (isInterface(_this__u8e3s4, FusibleFlow())) {
    tmp = _this__u8e3s4.h1d(VOID, capacity_0, onBufferOverflow_0);
  } else {
    tmp = new (ChannelFlowOperatorImpl())(_this__u8e3s4, VOID, capacity_0, onBufferOverflow_0);
  }
  return tmp;
}
function flowOn(_this__u8e3s4, context) {
  checkFlowContext(context);
  var tmp;
  if (equals(context, EmptyCoroutineContext_instance)) {
    tmp = _this__u8e3s4;
  } else {
    if (isInterface(_this__u8e3s4, FusibleFlow())) {
      tmp = _this__u8e3s4.h1d(context);
    } else {
      tmp = new (ChannelFlowOperatorImpl())(_this__u8e3s4, context);
    }
  }
  return tmp;
}
function checkFlowContext(context) {
  // Inline function 'kotlin.require' call
  if (!(context.yc(Key_instance) == null)) {
    var message = 'Flow context cannot contain job in it. Had ' + toString(context);
    throw IllegalArgumentException().n2(toString(message));
  }
}
//region block: exports
export {
  buffer as buffer2o7vhreze5nfc,
  flowOn as flowOn2q2f1gsn1yu9y,
};
//endregion

//# sourceMappingURL=Context.mjs.map
